import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";


function Home() {

  return (
    <>
      <Header />



      <main>
        {/*===== HERO AREA START =====*/}
        <div
          className="hero16-section"
          style={{
            backgroundImage: "url(assets/img/bg/11.png)",
            backgroundPosition: "center bottom",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
          }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5">
                <div className="heading16-area">
                  <h5 data-aos="fade-left" data-aos-duration={900}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={20}
                      height={20}
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M9.99935 1.66797C10.3121 1.66797 10.6205 1.68491 10.9243 1.7188C11.0331 1.73084 11.1385 1.76419 11.2344 1.81693C11.3303 1.86968 11.4148 1.9408 11.4832 2.02623C11.5516 2.11166 11.6025 2.20973 11.633 2.31483C11.6635 2.41994 11.6731 2.53002 11.661 2.6388C11.649 2.74758 11.6156 2.85292 11.5629 2.94881C11.5101 3.04471 11.439 3.12927 11.3536 3.19767C11.2682 3.26608 11.1701 3.31699 11.065 3.3475C10.9599 3.378 10.8498 3.38751 10.741 3.37547C9.36772 3.22184 7.98062 3.49875 6.77158 4.1679C5.56254 4.83706 4.59131 5.86538 3.99224 7.11063C3.39316 8.35589 3.19585 9.75653 3.42759 11.1188C3.65933 12.4811 4.30867 13.7377 5.2858 14.7149C6.26292 15.692 7.51954 16.3413 8.88183 16.5731C10.2441 16.8048 11.6448 16.6075 12.89 16.0084C14.1353 15.4093 15.1636 14.4381 15.8327 13.2291C16.5019 12.02 16.7788 10.6329 16.6252 9.25964C16.6131 9.15086 16.6226 9.04077 16.6532 8.93567C16.6837 8.83056 16.7346 8.7325 16.803 8.64707C16.9411 8.47453 17.1422 8.36395 17.3618 8.33964C17.5815 8.31532 17.8019 8.37928 17.9744 8.51743C18.0598 8.58584 18.131 8.6704 18.1837 8.76629C18.2365 8.86218 18.2698 8.96752 18.2818 9.0763C18.3152 9.38019 18.3321 9.68852 18.3327 10.0013C18.3327 14.6038 14.6018 18.3346 9.99935 18.3346C5.39685 18.3346 1.66602 14.6038 1.66602 10.0013C1.66602 5.3988 5.39685 1.66797 9.99935 1.66797ZM9.97268 6.56547C10.0276 6.77941 9.99534 7.00639 9.883 7.19656C9.77065 7.38672 9.5874 7.52451 9.37352 7.57964C8.78591 7.73356 8.27438 8.09603 7.93438 8.59939C7.59438 9.10276 7.44914 9.71264 7.52577 10.3152C7.60239 10.9178 7.89564 11.4719 8.3508 11.8742C8.80595 12.2764 9.39192 12.4993 9.99935 12.5013C10.5538 12.5015 11.0925 12.3175 11.5309 11.978C11.9693 11.6386 12.2824 11.1631 12.421 10.6263C12.4801 10.4166 12.6189 10.2384 12.8078 10.1298C12.9967 10.0212 13.2206 9.9909 13.4315 10.0454C13.6425 10.0999 13.8237 10.2348 13.9364 10.4212C14.049 10.6077 14.0842 10.8309 14.0343 11.043C13.7787 12.0229 13.175 12.8763 12.3361 13.4436C11.4972 14.011 10.4805 14.2535 9.47582 14.1259C8.47115 13.9983 7.5473 13.5093 6.87685 12.7502C6.20641 11.9912 5.83524 11.014 5.83268 10.0013C5.83254 9.07746 6.13943 8.17977 6.70511 7.44936C7.27079 6.71896 8.06318 6.19726 8.95768 5.9663C9.06367 5.93898 9.174 5.93281 9.28238 5.94814C9.39075 5.96347 9.49504 6 9.5893 6.05564C9.68355 6.11128 9.76592 6.18494 9.8317 6.27242C9.89749 6.35989 9.94539 6.45947 9.97268 6.56547ZM15.4193 1.7738C15.5715 1.83687 15.7015 1.94358 15.793 2.08048C15.8845 2.21737 15.9334 2.37831 15.9335 2.54297V4.06797H17.4577C17.6225 4.068 17.7836 4.1169 17.9206 4.20847C18.0576 4.30004 18.1644 4.43017 18.2274 4.58242C18.2905 4.73467 18.307 4.9022 18.2748 5.06383C18.2427 5.22546 18.1634 5.37393 18.0468 5.49047L15.0994 8.43464C14.9431 8.59093 14.7312 8.67876 14.5102 8.6788H12.4993L10.976 10.203C10.8196 10.3593 10.6076 10.4472 10.3864 10.4472C10.1653 10.4472 9.95322 10.3593 9.79685 10.203C9.64048 10.0466 9.55264 9.83452 9.55264 9.61339C9.55264 9.39225 9.64048 9.18017 9.79685 9.0238L11.321 7.5013V5.48964C11.3211 5.26864 11.4089 5.05671 11.5652 4.90047L14.511 1.9538C14.6276 1.83719 14.7761 1.75777 14.9377 1.72558C15.0994 1.69339 15.267 1.70988 15.4193 1.77297M14.2668 4.5538L12.9877 5.83464V7.01297H14.166L15.446 5.7338H15.1002C14.8792 5.7338 14.6672 5.646 14.5109 5.48972C14.3546 5.33344 14.2668 5.12148 14.2668 4.90047V4.5538Z"
                        fill="white"
                      />
                    </svg>{" "}
                    Atrangi Ashok.
                  </h5>
                  <div className="space16" />
                  <h2 data-aos="fade-left" data-aos-duration={1000}>
                    Hi, I'm Ashok Nanda.
                  </h2>
                  <div className="space16" />
                  <p data-aos="fade-left" data-aos-duration={1100}>
                    Author | Social Worker | Entrepreneur | Civil Society Leader | Mentor
                  </p>
                  <div className="space16" />
                  <p data-aos="fade-left" data-aos-duration={1100}>
                    I bring together literature, social action, enterprise, education and human development to create meaningful opportunities and contribute to a more humane, inclusive and dignified society.
                  </p>
                  <div className="space32" />

                </div>
              </div>
              <div className="col-lg-1" />
              <div className="col-lg-6">
                <div
                  className="hero16-img"
                  data-aos="zoom-out"
                  data-aos-duration={1000}
                >
                  <img src="assets/img/hero/ashokhome.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*===== HERO AREA START =====*/}


        {/*==== HERO AREA START =====*/}
        {/*===== ABOUT AREA START =====*/}
       <div className="about20-section-area sp"
       style={{
            backgroundImage: "url(assets/img/bg/2.png)",
            backgroundPosition: "center bottom",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
          }}
       >
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-6">
        <div className="about20-images-area">
          <div className="img1 image-anime reveal">
            <img src="assets/img/about/ashokabout.png" alt="" />
          </div>
          <div className="img2 reveal">
            <img src="assets/img/about/homeabout.png" alt="" />
          </div>
          <img
            src="assets/img/shapes/elements30.png"
            alt=""
            className="elements30"
          />
          <img
            src="assets/img/shapes/elements31.png"
            alt=""
            className="elements31"
          />
        </div>
      </div>
      <div className="col-lg-6">
        <div className="about20-header-area heading24">
          <h5>About Ashok Nanda</h5>
          <div className="space16" />
          <h2 className="text-anime-style-3">
            About Ashok Nanda
          </h2>
          <div className="space16" />
          <h3 data-aos="fade-left" data-aos-duration={1100}>
            Author, Social Worker, Entrepreneur &amp; Mentor
          </h3>
          <div className="space16" />
          <p data-aos="fade-left" data-aos-duration={1000}>
            Ashok Nanda is an author, social worker, entrepreneur, civil society leader and mentor whose work brings together literature, social action, enterprise, education and human development.
          </p>
          <p data-aos="fade-left" data-aos-duration={1000}>
            As an author, he writes fiction that critically explores human society, the metaphysics of living, human relationships and political economy. His writings seek to understand the forces that shape individual lives and society.
          </p>
          <p data-aos="fade-left" data-aos-duration={1000}>
            His work across social development, enterprise and education reflects a continuing commitment to creating opportunities and building a more inclusive society.
          </p>
          <div className="space32" />
          <h3 data-aos="fade-left" data-aos-duration={1100}>
            Highlights
          </h3>
          <div className="space8" />
          <div
            className="list-area"
            data-aos="fade-left"
            data-aos-duration={1200}
          >
            <ul>
              <li>
                <img src="assets/img/icons/check15.svg" alt="" />
                Literature &amp; Philosophy
              </li>
              <li>
                <img src="assets/img/icons/check15.svg" alt="" />
                Social Work &amp; Rehabilitation
              </li>
              <li>
                <img src="assets/img/icons/check15.svg" alt="" />
                Enterprise &amp; Institution Building
              </li>
              <li>
                <img src="assets/img/icons/check15.svg" alt="" />
                Leadership &amp; Mentoring
              </li>
            </ul>
          </div>
        {/* <div className="col-lg-12">
  <div className="space12" />
  <div
                          className="btn-area1 aos-init aos-animate"
                          data-aos="fade-left"
                          data-aos-duration={1200}
                        >
                          <Link to ="/Contact" className="theme-btn34">
                            Contact Now <i className="fa-solid fa-arrow-right" />
                          </Link>
                        </div>
</div> */}

        </div>
      </div>
    </div>
  </div>
</div>













        {/* my goal end */}


      <div className="about14-section sp"
      
        style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/18.png)`,
            backgroundPosition: "center bottom",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
          }}>
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-6">
        <div className="about14-heading heading14">
          <h5 data-aos="fade-left" data-aos-duration={900}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M9.99935 1.66699C10.3121 1.66699 10.6205 1.68394 10.9243 1.71783C11.0331 1.72986 11.1385 1.76321 11.2344 1.81596C11.3303 1.86871 11.4148 1.93983 11.4832 2.02526C11.5516 2.11069 11.6025 2.20875 11.633 2.31386C11.6635 2.41896 11.6731 2.52905 11.661 2.63783C11.649 2.7466 11.6156 2.85195 11.5629 2.94784C11.5101 3.04373 11.439 3.12829 11.3536 3.1967C11.2682 3.2651 11.1701 3.31601 11.065 3.34652C10.9599 3.37702 10.8498 3.38653 10.741 3.37449C9.36772 3.22086 7.98062 3.49778 6.77158 4.16693C5.56254 4.83608 4.59131 5.8644 3.99224 7.10966C3.39316 8.35491 3.19585 9.75555 3.42759 11.1178C3.65933 12.4801 4.30867 13.7368 5.2858 14.7139C6.26292 15.691 7.51954 16.3403 8.88183 16.5721C10.2441 16.8038 11.6448 16.6065 12.89 16.0074C14.1353 15.4084 15.1636 14.4371 15.8327 13.2281C16.5019 12.0191 16.7788 10.632 16.6252 9.25866C16.6131 9.14988 16.6227 9.0398 16.6532 8.93469C16.6837 8.82959 16.7346 8.73152 16.803 8.64609C16.9411 8.47356 17.1422 8.36297 17.3618 8.33866C17.5815 8.31435 17.8019 8.3783 17.9744 8.51645C18.0598 8.58486 18.131 8.66942 18.1837 8.76531C18.2365 8.86121 18.2698 8.96655 18.2818 9.07533C18.3152 9.37922 18.3321 9.68755 18.3327 10.0003C18.3327 14.6028 14.6018 18.3337 9.99935 18.3337C5.39685 18.3337 1.66602 14.6028 1.66602 10.0003C1.66602 5.39783 5.39685 1.66699 9.99935 1.66699ZM9.97268 6.56449C10.0276 6.77843 9.99534 7.00542 9.883 7.19558C9.77065 7.38575 9.5874 7.52353 9.37352 7.57866C8.78591 7.73259 8.27438 8.09505 7.93438 8.59842C7.59438 9.10178 7.44914 9.71166 7.52577 10.3142C7.60239 10.9168 7.89564 11.4709 8.3508 11.8732C8.80595 12.2754 9.39192 12.4984 9.99935 12.5003C10.5538 12.5006 11.0925 12.3165 11.5309 11.9771C11.9693 11.6377 12.2824 11.1621 12.421 10.6253C12.4801 10.4156 12.6189 10.2374 12.8078 10.1288C12.9967 10.0202 13.2206 9.98992 13.4315 10.0444C13.6425 10.0989 13.8237 10.2338 13.9364 10.4203C14.049 10.6067 14.0842 10.8299 14.0343 11.042C13.7787 12.0219 13.175 12.8753 12.3361 13.4426C11.4972 14.01 10.4805 14.2525 9.47582 14.1249C8.47115 13.9973 7.5473 13.5083 6.87685 12.7493C6.20641 11.9902 5.83524 11.0131 5.83268 10.0003C5.83254 9.07648 6.13943 8.17879 6.70511 7.44839C7.27079 6.71798 8.06318 6.19629 8.95768 5.96533C9.06367 5.93801 9.174 5.93184 9.28238 5.94717C9.39075 5.96249 9.49504 5.99902 9.5893 6.05466C9.68355 6.1103 9.76592 6.18396 9.8317 6.27144C9.89748 6.35892 9.94539 6.4585 9.97268 6.56449ZM15.4193 1.77283C15.5715 1.83589 15.7015 1.94261 15.793 2.0795C15.8845 2.21639 15.9334 2.37733 15.9335 2.54199V4.06699H17.4577C17.6225 4.06703 17.7836 4.11592 17.9206 4.20749C18.0576 4.29906 18.1644 4.4292 18.2274 4.58145C18.2905 4.7337 18.307 4.90122 18.2748 5.06285C18.2427 5.22448 18.1634 5.37295 18.0469 5.48949L15.0993 8.43366C14.9431 8.58995 14.7312 8.67778 14.5102 8.67783H12.4993L10.976 10.202C10.8196 10.3584 10.6076 10.4462 10.3864 10.4462C10.1653 10.4462 9.95322 10.3584 9.79685 10.202C9.64048 10.0456 9.55264 9.83355 9.55264 9.61241C9.55264 9.39127 9.64048 9.17919 9.79685 9.02283L11.321 7.50033V5.48866C11.3211 5.26766 11.4089 5.05574 11.5652 4.89949L14.511 1.95283C14.6276 1.83621 14.7761 1.75679 14.9377 1.7246C15.0994 1.69241 15.267 1.7089 15.4193 1.77199M14.2668 4.55283L12.9877 5.83366V7.01199H14.166L15.446 5.73283H15.1002C14.8792 5.73283 14.6672 5.64503 14.5109 5.48875C14.3546 5.33247 14.2668 5.12051 14.2668 4.89949V4.55283Z"
                fill="#050422"
              />
            </svg>{" "}
            Ambitious
          </h5>
          <div className="space16" />
          <h2 className="text-anime-style-3">
            Social Work &amp; Community Impact
          </h2>
          <div className="space16" />
          <p data-aos="fade-left" data-aos-duration={1000}>
            For many years, Ashok Nanda has worked with people affected by leprosy, persons with disabilities, women, indigenous communities and other marginalized groups.
          </p>
          <p data-aos="fade-left" data-aos-duration={1000}>
            His work has included relief and rehabilitation, shelter and livelihood rights, communal harmony and wider issues of social development.
          </p>
          <p data-aos="fade-left" data-aos-duration={1000}>
            His continuing purpose is to help create a society where every individual has the opportunity to live with dignity, participate in community life and pursue a better future.
          </p>
          <div className="space32" />
          <div
            className="abotu14-boxarea"
            data-aos="fade-left"
            data-aos-duration={1100}
          >
            <div className="icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={28}
                height={28}
                viewBox="0 0 28 28"
                fill="none"
              >
                <path
                  d="M14.0007 25.6663C7.55733 25.6663 2.33398 20.4429 2.33398 13.9997C2.33398 7.55635 7.55733 2.33301 14.0007 2.33301C20.4439 2.33301 25.6673 7.55635 25.6673 13.9997C25.6673 20.4429 20.4439 25.6663 14.0007 25.6663ZM12.837 18.6663L21.0866 10.4168L19.4367 8.76685L12.837 15.3665L9.53723 12.0666L7.88731 13.7166L12.837 18.6663Z"
                  fill="#6F00FF"
                />
              </svg>
            </div>
            <div className="textarea14">
              <a href="#">Human Dignity &amp; Opportunity</a>
              <div className="space16" />
              <p>
                Supporting inclusion, rehabilitation, livelihoods and meaningful opportunities for marginalized communities.
              </p>
            </div>
          </div>
          <div className="space32" />
          <div
            className="btn-area1"
            data-aos="fade-left"
            data-aos-duration={1200}
          >
            <Link to="/activities" className="theme-btn27">
              Explore My Work
            </Link>
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="about14-images-area">
          <div className="img1" data-aos="zoom-out" data-aos-duration={1000}>
            <img src={`${process.env.PUBLIC_URL}/assets/img/about/goal1-1.png`} alt="" />
          </div>
          <div className="img2" data-aos="zoom-out" data-aos-duration={1100}>
            <img src={`${process.env.PUBLIC_URL}/assets/img/about/goal-1.png`} alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>










<div className="about23-section sp"
    style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/bg6777.png)`,
            backgroundPosition: "center bottom",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
          }}>

  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-6">
        <div className="about23-images-area">
          <img
            src={`${process.env.PUBLIC_URL}/assets/img/others/about23-elements1.png`}
            alt=""
            className="about23-elements1"
          />
          <div className="img1 reveal">
            <img src={`${process.env.PUBLIC_URL}/assets/img/about/heart-2.png`} alt="" />
          </div>
          <div className="img2 text-end reveal">
            <img src={`${process.env.PUBLIC_URL}/assets/img/about/heart-1.png`} alt="" />
          </div>
          <div
            className="video-buttton23 play-btn"
            href="ash1.mp4"
          >
            <a id="play-video" className="video-play-button">
              <span />
            </a>
            <p>Watch My Story</p>
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="about23-header heading28">
          <h5 data-aos="fade-left" data-aos-duration={800}>
            <img src={`${process.env.PUBLIC_URL}/assets/img/icons/span24.svg`} alt="" />
            My Story
          </h5>
          <div className="space16" />
          <h2 className="text-anime-style-3">
            A Journey of Ideas, Action &amp; Human Potential
          </h2>
          <div className="space20" />
          <p data-aos="fade-left" data-aos-duration={1000}>
            From writing about the human condition to working with marginalized communities, building enterprises and mentoring future leaders, Ashok Nanda's journey has brought together diverse experiences in literature, social work, education and enterprise.
          </p>
          <p data-aos="fade-left" data-aos-duration={1000}>
            Today, mentoring is an important part of his work. He guides leaders, managers, entrepreneurs, institutions and young people, drawing on his experience across social work, enterprise, cooperatives, education and civil society.
          </p>
          <p data-aos="fade-left" data-aos-duration={1000}>
            His approach is simple: Think deeply. Act practically. Build institutions. Create opportunities.
          </p>
          {/* <div className="about-boxarea">
            <div className="row">
              <div
                className="col-lg-6 col-md-6"
                data-aos="zoom-in"
                data-aos-duration={900}
              >
                <div className="box1">
                  <div className="icons">
                    <img src="assets/img/icons/service23-icon1.svg" alt="" />
                  </div>
                  <div className="space16" />
                  <a href="team.html">Meet the Experts Behind Your Success</a>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-6"
                data-aos="zoom-in"
                data-aos-duration={1000}
              >
                <div className="box1">
                  <div className="icons">
                    <img src="assets/img/icons/service23-icon2.svg" alt="" />
                  </div>
                  <div className="space16" />
                  <a href="team.html">
                    The Team Behind Your Strategic Advantage
                  </a>
                </div>
              </div>
            </div>
          </div> */}
          <div className="space40" />
          <div
            className="btn-area1"
            data-aos="zoom-in"
            data-aos-duration={1200}
          >
            <Link to="/Expertise" className="theme-btn41">
              Watch My Journey
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>













   <div className="about18-section-area sp"
   style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/change1.png)`,
            backgroundPosition: "center bottom",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
          }}>
   
                <div className="container">
                  <div className="row align-items-center">

                      <div className="col-lg-6">
                      <div className="about18-header heading20">
                        <h5
                          data-aos="fade-left"
                          data-aos-duration={800}
                          className="aos-init aos-animate"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={20}
                            height={20}
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_4011_1559)">
                              <path
                                d="M9.188 9.38927C8.32474 8.97925 6.81094 8.62971 4.98387 8.54589C2.10233 8.4137 -4.69866e-07 9.25072 -4.31861e-07 10.1202C-4.07142e-07 10.6857 0.943944 11.1815 2.36128 11.4591C1.81918 11.231 1.5202 10.9406 1.5202 10.5949C1.5202 9.82827 4.09794 8.34761 7.9315 9.14076C8.38888 9.23539 8.80673 9.31722 9.188 9.38927Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.812 10.6107C11.6753 11.0207 13.1891 11.3703 15.0161 11.4541C17.8977 11.5863 20 10.7493 20 9.87983C20 9.31432 19.0561 8.81846 17.6387 8.54088C18.1808 8.769 18.4798 9.05939 18.4798 9.40515C18.4798 10.1717 15.9021 11.6524 12.0685 10.8592C11.6111 10.7646 11.1933 10.6828 10.812 10.6107Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.6107 9.18799C11.0208 8.32474 11.3703 6.81094 11.4541 4.98387C11.5863 2.10233 10.7493 -2.37721e-06 9.87983 -2.33921e-06C9.31433 -2.31449e-06 8.81847 0.943943 8.54088 2.36127C8.76901 1.81918 9.05939 1.5202 9.40515 1.5202C10.1717 1.5202 11.6524 4.09794 10.8592 7.9315C10.7646 8.38887 10.6828 8.80673 10.6107 9.18799Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M9.38927 10.812C8.97925 11.6753 8.62971 13.1891 8.54589 15.0161C8.4137 17.8977 9.25072 20 10.1202 20C10.6857 20 11.1815 19.0561 11.4591 17.6387C11.231 18.1808 10.9406 18.4798 10.5949 18.4798C9.82827 18.4798 8.34761 15.9021 9.14076 12.0685C9.23539 11.6111 9.31722 11.1933 9.38927 10.812Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M9.85765 8.99397C9.53717 8.09363 8.71391 6.77605 7.48125 5.42485C5.53716 3.29382 3.45873 2.39911 2.84393 3.0139C2.44406 3.41378 2.76091 4.43187 3.56683 5.63036C3.34482 5.08573 3.33875 4.66899 3.58323 4.4245C4.12529 3.88245 6.99501 4.6582 9.14491 7.92977C9.4014 8.3201 9.63901 8.67343 9.85765 8.99397Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.1423 11.006C10.4628 11.9064 11.286 13.224 12.5187 14.5751C14.4628 16.7062 16.5412 17.6009 17.156 16.9861C17.5559 16.5862 17.239 15.5681 16.4331 14.3696C16.6551 14.9143 16.6612 15.331 16.4167 15.5755C15.8747 16.1175 13.0049 15.3418 10.8551 12.0702C10.5986 11.6799 10.3609 11.3266 10.1423 11.006Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M11.006 9.85767C11.9063 9.53719 13.2239 8.71393 14.5751 7.48127C16.7062 5.53719 17.6009 3.45875 16.9861 2.84396C16.5862 2.44409 15.5681 2.76093 14.3696 3.56685C14.9142 3.34484 15.331 3.33877 15.5755 3.58325C16.1175 4.12531 15.3418 6.99503 12.0702 9.14493C11.6799 9.40142 11.3265 9.63903 11.006 9.85767Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M8.99396 10.1423C8.09361 10.4628 6.77603 11.2861 5.42483 12.5187C3.2938 14.4628 2.39909 16.5412 3.01388 17.156C3.41376 17.5559 4.43185 17.2391 5.63034 16.4331C5.08571 16.6552 4.66897 16.6612 4.42448 16.4167C3.88243 15.8747 4.65818 13.005 7.92975 10.8551C8.32008 10.5986 8.67342 10.361 8.99396 10.1423Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M9.0161 9.7465C8.06164 9.69804 6.52931 9.95442 4.80925 10.5762C2.09647 11.5568 0.474475 13.1346 0.8072 13.9379C1.02361 14.4603 2.08546 14.5572 3.50113 14.2713C2.91299 14.268 2.52565 14.1141 2.39334 13.7946C2.09998 13.0864 3.91487 10.732 7.76015 9.99774C8.21892 9.91014 8.63629 9.82584 9.0161 9.7465Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.9839 10.2535C11.9384 10.302 13.4707 10.0456 15.1908 9.42383C17.9035 8.44324 19.5255 6.86541 19.1928 6.06214C18.9764 5.53969 17.9146 5.4428 16.4989 5.72874C17.087 5.73204 17.4744 5.88592 17.6067 6.20535C17.9 6.91358 16.0851 9.26799 12.2399 10.0023C11.7811 10.0899 11.3637 10.1742 10.9839 10.2535Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.2535 9.01609C10.302 8.06164 10.0456 6.5293 9.42384 4.80924C8.44325 2.09646 6.86542 0.474468 6.06215 0.807193C5.53969 1.0236 5.44281 2.08545 5.72875 3.50112C5.73205 2.91299 5.88592 2.52565 6.20536 2.39333C6.91359 2.09997 9.268 3.91487 10.0023 7.76014C10.0899 8.21891 10.1742 8.63628 10.2535 9.01609Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M9.74651 10.9839C9.69805 11.9384 9.95442 13.4707 10.5762 15.1908C11.5568 17.9035 13.1346 19.5255 13.9379 19.1928C14.4603 18.9764 14.5572 17.9146 14.2713 16.4989C14.268 17.087 14.1141 17.4744 13.7947 17.6067C13.0864 17.9 10.732 16.0851 9.99775 12.2399C9.91015 11.7811 9.82585 11.3637 9.74651 10.9839Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M9.4835 9.12502C8.84287 8.41585 7.57806 7.51361 5.92215 6.73699C3.31054 5.51215 1.04792 5.48092 0.715199 6.28419C0.49879 6.80664 1.18112 7.62599 2.38434 8.42484C1.97081 8.00662 1.80572 7.62393 1.93803 7.30449C2.23139 6.59627 5.17954 6.21477 8.41776 8.41458C8.8041 8.67704 9.15884 8.91255 9.4835 9.12502Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.5165 10.875C11.1571 11.5841 12.4219 12.4864 14.0778 13.263C16.6894 14.4879 18.952 14.5191 19.2848 13.7158C19.5012 13.1934 18.8188 12.374 17.6156 11.5752C18.0292 11.9934 18.1942 12.3761 18.0619 12.6955C17.7686 13.4037 14.8204 13.7852 11.5822 11.5854C11.1959 11.323 10.8411 11.0874 10.5165 10.875Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.875 9.48352C11.5841 8.84288 12.4864 7.57808 13.263 5.92216C14.4878 3.31056 14.5191 1.04794 13.7158 0.715215C13.1933 0.498807 12.374 1.18114 11.5751 2.38436C11.9934 1.97082 12.3761 1.80574 12.6955 1.93805C13.4037 2.23141 13.7852 5.17955 11.5854 8.41777C11.3229 8.80412 11.0874 9.15885 10.875 9.48352Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M9.125 10.5165C8.41584 11.1571 7.5136 12.4219 6.73697 14.0778C5.51213 16.6894 5.4809 18.9521 6.28417 19.2848C6.80663 19.5012 7.62598 18.8189 8.42482 17.6156C8.00661 18.0292 7.62391 18.1943 7.30448 18.0619C6.59625 17.7686 6.21475 14.8204 8.41457 11.5822C8.67702 11.1959 8.91254 10.8411 9.125 10.5165Z"
                                fill="#2C61DD"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_4011_1559">
                                <rect width={20} height={20} fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          
                        </h5>
                        <div className="space24" />
                        <h2 className="text-anime-style-3">
                          Areas of Work
                        </h2>
                        <div className="space16" />
                        <p
                          data-aos="fade-left"
                          data-aos-duration={1000}
                          className="aos-init aos-animate"
                        >
                          Ashok Nanda's work spans literature, social development, enterprise, education, human potential and leadership. These interconnected areas reflect his continuing interest in developing human potential and creating opportunities for a more inclusive society.
                        </p>
                        <div className="space24" />
                        <div className="row g-3 aos-init aos-animate" data-aos="fade-left" data-aos-duration={1100}>
                          {[
                            "Literature & Philosophy",
                            "Social Work & Rehabilitation",
                            "Human Rights & Livelihoods",
                            "Communal Harmony",
                            "Cooperatives & Enterprise",
                            "Employment Generation",
                            "Education & Employability",
                            "Meditation & Human Development",
                            "Body, Metabolism & Healthy Ageing",
                            "Leadership & Institutional Mentoring"
                          ].reduce((rows, item, index) => {
                            const column = Math.floor(index / 5);
                            if (!rows[column]) rows[column] = [];
                            rows[column].push(item);
                            return rows;
                          }, []).map((columnItems, columnIndex) => (
                            <div key={columnIndex} className="col-lg-6">
                              <div className="d-flex flex-column gap-3">
                                {columnItems.map((item) => (
                                  <div key={item} className="d-flex align-items-center gap-3">
                                    <span
                                      className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white"
                                      style={{ width: "24px", height: "24px", minWidth: "24px", fontSize: "14px", flexShrink: 0 }}
                                    >
                                      <i className="fa-solid fa-check" />
                                    </span>
                                    <span className="fw-semibold text-dark" style={{ fontSize: "1.05rem", lineHeight: 1.4 }}>
                                      {item}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="space32" />
                        <div
                          className="btn-area1 aos-init aos-animate"
                          data-aos="fade-left"
                          data-aos-duration={1200}
                        >
                          <Link to="/activities" className="theme-btn27">
                            Explore My Work
                          </Link>
                        </div>
                      </div>
                    </div>



                    
                    <div className="col-lg-6">
                      <div className="about-images-area">
                        <div className="row align-items-center">
                          <div className="col-lg-6 col-md-6">
                            <div
                              className="img1 reveal image-anime"
                              style={{
                                opacity: 1,
                                visibility: "inherit",
                                translate: "none",
                                rotate: "none",
                                scale: "none",
                                transform: "translate(0px, 0px)"
                              }}
                            >
                              <img
                                src={`${process.env.PUBLIC_URL}/assets/img/about/care-2.png`}
                                alt=""
                                style={{
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)"
                                }}
                              />
                            </div>
                            <div className="space30 d-md-none d-block" />
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div
                              className="img1 reveal image-anime"
                              style={{
                                opacity: 1,
                                visibility: "inherit",
                                translate: "none",
                                rotate: "none",
                                scale: "none",
                                transform: "translate(0px, 0px)"
                              }}
                            >
                              <img
                                src={`${process.env.PUBLIC_URL}/assets/img/about/care3.png`}
                                alt=""
                                style={{
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)"
                                }}
                              />
                            </div>
                            <div className="space30" />
                            <div
                              className="img1 reveal image-anime"
                              style={{
                                opacity: 1,
                                visibility: "inherit",
                                translate: "none",
                                rotate: "none",
                                scale: "none",
                                transform: "translate(0px, 0px)"
                              }}
                            >
                              <img
                                src={`${process.env.PUBLIC_URL}/assets/img/about/care-1.png`}
                                alt=""
                                style={{
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)"
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-lg-6">
                      <div className="about18-header heading20">
                        <h5
                          data-aos="fade-left"
                          data-aos-duration={800}
                          className="aos-init aos-animate"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={20}
                            height={20}
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_4011_1559)">
                              <path
                                d="M9.188 9.38927C8.32474 8.97925 6.81094 8.62971 4.98387 8.54589C2.10233 8.4137 -4.69866e-07 9.25072 -4.31861e-07 10.1202C-4.07142e-07 10.6857 0.943944 11.1815 2.36128 11.4591C1.81918 11.231 1.5202 10.9406 1.5202 10.5949C1.5202 9.82827 4.09794 8.34761 7.9315 9.14076C8.38888 9.23539 8.80673 9.31722 9.188 9.38927Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.812 10.6107C11.6753 11.0207 13.1891 11.3703 15.0161 11.4541C17.8977 11.5863 20 10.7493 20 9.87983C20 9.31432 19.0561 8.81846 17.6387 8.54088C18.1808 8.769 18.4798 9.05939 18.4798 9.40515C18.4798 10.1717 15.9021 11.6524 12.0685 10.8592C11.6111 10.7646 11.1933 10.6828 10.812 10.6107Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.6107 9.18799C11.0208 8.32474 11.3703 6.81094 11.4541 4.98387C11.5863 2.10233 10.7493 -2.37721e-06 9.87983 -2.33921e-06C9.31433 -2.31449e-06 8.81847 0.943943 8.54088 2.36127C8.76901 1.81918 9.05939 1.5202 9.40515 1.5202C10.1717 1.5202 11.6524 4.09794 10.8592 7.9315C10.7646 8.38887 10.6828 8.80673 10.6107 9.18799Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M9.38927 10.812C8.97925 11.6753 8.62971 13.1891 8.54589 15.0161C8.4137 17.8977 9.25072 20 10.1202 20C10.6857 20 11.1815 19.0561 11.4591 17.6387C11.231 18.1808 10.9406 18.4798 10.5949 18.4798C9.82827 18.4798 8.34761 15.9021 9.14076 12.0685C9.23539 11.6111 9.31722 11.1933 9.38927 10.812Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M9.85765 8.99397C9.53717 8.09363 8.71391 6.77605 7.48125 5.42485C5.53716 3.29382 3.45873 2.39911 2.84393 3.0139C2.44406 3.41378 2.76091 4.43187 3.56683 5.63036C3.34482 5.08573 3.33875 4.66899 3.58323 4.4245C4.12529 3.88245 6.99501 4.6582 9.14491 7.92977C9.4014 8.3201 9.63901 8.67343 9.85765 8.99397Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.1423 11.006C10.4628 11.9064 11.286 13.224 12.5187 14.5751C14.4628 16.7062 16.5412 17.6009 17.156 16.9861C17.5559 16.5862 17.239 15.5681 16.4331 14.3696C16.6551 14.9143 16.6612 15.331 16.4167 15.5755C15.8747 16.1175 13.0049 15.3418 10.8551 12.0702C10.5986 11.6799 10.3609 11.3266 10.1423 11.006Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M11.006 9.85767C11.9063 9.53719 13.2239 8.71393 14.5751 7.48127C16.7062 5.53719 17.6009 3.45875 16.9861 2.84396C16.5862 2.44409 15.5681 2.76093 14.3696 3.56685C14.9142 3.34484 15.331 3.33877 15.5755 3.58325C16.1175 4.12531 15.3418 6.99503 12.0702 9.14493C11.6799 9.40142 11.3265 9.63903 11.006 9.85767Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M8.99396 10.1423C8.09361 10.4628 6.77603 11.2861 5.42483 12.5187C3.2938 14.4628 2.39909 16.5412 3.01388 17.156C3.41376 17.5559 4.43185 17.2391 5.63034 16.4331C5.08571 16.6552 4.66897 16.6612 4.42448 16.4167C3.88243 15.8747 4.65818 13.005 7.92975 10.8551C8.32008 10.5986 8.67342 10.361 8.99396 10.1423Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M9.0161 9.7465C8.06164 9.69804 6.52931 9.95442 4.80925 10.5762C2.09647 11.5568 0.474475 13.1346 0.8072 13.9379C1.02361 14.4603 2.08546 14.5572 3.50113 14.2713C2.91299 14.268 2.52565 14.1141 2.39334 13.7946C2.09998 13.0864 3.91487 10.732 7.76015 9.99774C8.21892 9.91014 8.63629 9.82584 9.0161 9.7465Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.9839 10.2535C11.9384 10.302 13.4707 10.0456 15.1908 9.42383C17.9035 8.44324 19.5255 6.86541 19.1928 6.06214C18.9764 5.53969 17.9146 5.4428 16.4989 5.72874C17.087 5.73204 17.4744 5.88592 17.6067 6.20535C17.9 6.91358 16.0851 9.26799 12.2399 10.0023C11.7811 10.0899 11.3637 10.1742 10.9839 10.2535Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.2535 9.01609C10.302 8.06164 10.0456 6.5293 9.42384 4.80924C8.44325 2.09646 6.86542 0.474468 6.06215 0.807193C5.53969 1.0236 5.44281 2.08545 5.72875 3.50112C5.73205 2.91299 5.88592 2.52565 6.20536 2.39333C6.91359 2.09997 9.268 3.91487 10.0023 7.76014C10.0899 8.21891 10.1742 8.63628 10.2535 9.01609Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M9.74651 10.9839C9.69805 11.9384 9.95442 13.4707 10.5762 15.1908C11.5568 17.9035 13.1346 19.5255 13.9379 19.1928C14.4603 18.9764 14.5572 17.9146 14.2713 16.4989C14.268 17.087 14.1141 17.4744 13.7947 17.6067C13.0864 17.9 10.732 16.0851 9.99775 12.2399C9.91015 11.7811 9.82585 11.3637 9.74651 10.9839Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M9.4835 9.12502C8.84287 8.41585 7.57806 7.51361 5.92215 6.73699C3.31054 5.51215 1.04792 5.48092 0.715199 6.28419C0.49879 6.80664 1.18112 7.62599 2.38434 8.42484C1.97081 8.00662 1.80572 7.62393 1.93803 7.30449C2.23139 6.59627 5.17954 6.21477 8.41776 8.41458C8.8041 8.67704 9.15884 8.91255 9.4835 9.12502Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.5165 10.875C11.1571 11.5841 12.4219 12.4864 14.0778 13.263C16.6894 14.4879 18.952 14.5191 19.2848 13.7158C19.5012 13.1934 18.8188 12.374 17.6156 11.5752C18.0292 11.9934 18.1942 12.3761 18.0619 12.6955C17.7686 13.4037 14.8204 13.7852 11.5822 11.5854C11.1959 11.323 10.8411 11.0874 10.5165 10.875Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M10.875 9.48352C11.5841 8.84288 12.4864 7.57808 13.263 5.92216C14.4878 3.31056 14.5191 1.04794 13.7158 0.715215C13.1933 0.498807 12.374 1.18114 11.5751 2.38436C11.9934 1.97082 12.3761 1.80574 12.6955 1.93805C13.4037 2.23141 13.7852 5.17955 11.5854 8.41777C11.3229 8.80412 11.0874 9.15885 10.875 9.48352Z"
                                fill="#2C61DD"
                              />
                              <path
                                d="M9.125 10.5165C8.41584 11.1571 7.5136 12.4219 6.73697 14.0778C5.51213 16.6894 5.4809 18.9521 6.28417 19.2848C6.80663 19.5012 7.62598 18.8189 8.42482 17.6156C8.00661 18.0292 7.62391 18.1943 7.30448 18.0619C6.59625 17.7686 6.21475 14.8204 8.41457 11.5822C8.67702 11.1959 8.91254 10.8411 9.125 10.5165Z"
                                fill="#2C61DD"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_4011_1559">
                                <rect width={20} height={20} fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          About SEOC
                        </h5>
                        <div className="space24" />
                        <h2 className="text-anime-style-3" style={{ perspective: 400 }}>
                          <div
                            className="split-line"
                            style={{
                              display: "block",
                              textAlign: "start",
                              position: "relative"
                            }}
                          >
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                E
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                l
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                e
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                v
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                a
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                t
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                e
                              </div>
                            </div>{" "}
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                Y
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                o
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                u
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                r
                              </div>
                            </div>{" "}
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                W
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                o
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                r
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                k
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                f
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                o
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                r
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                c
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                e
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                ,
                              </div>
                            </div>{" "}
                          </div>
                          <div
                            className="split-line"
                            style={{
                              display: "block",
                              textAlign: "start",
                              position: "relative"
                            }}
                          >
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                E
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                l
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                e
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                v
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                a
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                t
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                e
                              </div>
                            </div>{" "}
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                B
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                e
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                s
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                t
                              </div>
                            </div>{" "}
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                B
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                u
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                s
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                i
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                n
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                e
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                s
                              </div>
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  translate: "none",
                                  rotate: "none",
                                  scale: "none",
                                  transform: "translate(0px, 0px)",
                                  opacity: 1
                                }}
                              >
                                s
                              </div>
                            </div>
                          </div>
                        </h2>
                        <div className="space16" />
                        <p
                          data-aos="fade-left"
                          data-aos-duration={1000}
                          className="aos-init aos-animate"
                        >
                          At SEOC, we understand that key to business success lies in having
                          the right people on your team. That's why we're committed to
                          connecting you with top-tier talent.
                        </p>
                        <div className="space8" />
                        <div
                          className="row aos-init aos-animate"
                          data-aos="fade-left"
                          data-aos-duration={1100}
                        >
                          <div className="col-lg-7">
                            <ul>
                              <li>
                                <img src="assets/img/icons/check14.svg" alt="" /> Tailored
                                Staffing Solutions
                              </li>
                              <li>
                                <img src="assets/img/icons/check14.svg" alt="" /> Streamlined
                                Hiring Process
                              </li>
                            </ul>
                          </div>
                          <div className="col-lg-5">
                            <ul>
                              <li>
                                <img src="assets/img/icons/check14.svg" alt="" /> Ongoing
                                Support
                              </li>
                              <li>
                                <img src="assets/img/icons/check14.svg" alt="" /> Experience
                                Team
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="space32" />
                        <div
                          className="btn-area1 aos-init aos-animate"
                          data-aos="fade-left"
                          data-aos-duration={1200}
                        >
                          <a href="contact.html" className="theme-btn34">
                            Join Our Network <i className="fa-solid fa-arrow-right" />
                          </a>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>












             






















       






        {/*=== TESTIMONIAL AREA START === */}
        {/* <div className="testimonial sp">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 m-auto text-center">
                                <div className="heading6 _mt-50">
                                    <span className="sub-title">Testimonial</span>
                                    <h2 className="text-anime-style-3">
                                        Trusted by Businesses and Professionals Alike
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-30 align-items-center">
                            <div className="col-lg-6">
                                <div className="tes6-image image-anime reveal mt-30">
                                    <img
                                        className="w-full"
                                        src="assets/img/testimonial/tes6-image.png"
                                        alt=""
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="tes6-slider-all mt-30">
                                    <div className="tes6-slider-content">
                                        <div className="tes6-slider">
                                            <div className="tes6-single-slider">
                                                <div className="stars">
                                                    <ul>
                                                        <li>
                                                            <i className="fa-solid fa-star" />
                                                        </li>
                                                        <li>
                                                            <i className="fa-solid fa-star" />
                                                        </li>
                                                        <li>
                                                            <i className="fa-solid fa-star" />
                                                        </li>
                                                        <li>
                                                            <i className="fa-solid fa-star" />
                                                        </li>
                                                        <li>
                                                            <i className="fa-solid fa-star" />
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="qoute">
                                                    <img src="assets/img/icons/qoute6.svg" alt="" />
                                                </div>
                                                <p className="content-text">
                                                    “At Seo, we measure our success by the satisfaction of our
                                                    clients and candidates. Every placement we make is a
                                                    testament to our dedication, expertise, &amp; commitment to
                                                    excellence From helping businesses find the right.”
                                                </p>
                                                <div className="bottom-area">
                                                    <div className="author-area">
                                                        <div className="author-image">
                                                            <img
                                                                src="assets/img/testimonial/team2-image2.png"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="author-text">
                                                            <a href="#">James Reynolds</a>
                                                            <p>Marketing Director</p>
                                                        </div>
                                                    </div>
                                                    <div className="google-logo">
                                                        <img src="assets/img/others/google6.png" alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tes6-single-slider">
                                                <div className="stars">
                                                    <ul>
                                                        <li>
                                                            <i className="fa-solid fa-star" />
                                                        </li>
                                                        <li>
                                                            <i className="fa-solid fa-star" />
                                                        </li>
                                                        <li>
                                                            <i className="fa-solid fa-star" />
                                                        </li>
                                                        <li>
                                                            <i className="fa-solid fa-star" />
                                                        </li>
                                                        <li>
                                                            <i className="fa-solid fa-star" />
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="qoute">
                                                    <img src="assets/img/icons/qoute6.svg" alt="" />
                                                </div>
                                                <p className="content-text">
                                                    “At Seo, we measure our success by the satisfaction of our
                                                    clients and candidates. Every placement we make is a
                                                    testament to our dedication, expertise, &amp; commitment to
                                                    excellence From helping businesses find the right.”
                                                </p>
                                                <div className="bottom-area">
                                                    <div className="author-area">
                                                        <div className="author-image">
                                                            <img
                                                                src="assets/img/testimonial/team2-image2.png"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="author-text">
                                                            <a href="#">James Reynolds</a>
                                                            <p>Marketing Director</p>
                                                        </div>
                                                    </div>
                                                    <div className="google-logo">
                                                        <img src="assets/img/others/google6.png" alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tes6-slider-btns">
                                        <button className="tes6-next-arrow">
                                            <i className="fa-regular fa-arrow-left" />
                                        </button>
                                        <button className="tes6-prev-arrow">
                                            <i className="fa-regular fa-arrow-right" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
        {/*=== TESTIMONIAL AREA END === */}




        {/*===== CASE AREA STARTS =======*/}
        {/* <div className="case18-section-area sp"
        
       >

          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="case-header heading20-w">
                  <h5>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={20}
                      height={20}
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_4011_1559)">
                        <path
                          d="M9.188 9.38927C8.32474 8.97925 6.81094 8.62971 4.98387 8.54589C2.10233 8.4137 -4.69866e-07 9.25072 -4.31861e-07 10.1202C-4.07142e-07 10.6857 0.943944 11.1815 2.36128 11.4591C1.81918 11.231 1.5202 10.9406 1.5202 10.5949C1.5202 9.82827 4.09794 8.34761 7.9315 9.14076C8.38888 9.23539 8.80673 9.31722 9.188 9.38927Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M10.812 10.6107C11.6753 11.0207 13.1891 11.3703 15.0161 11.4541C17.8977 11.5863 20 10.7493 20 9.87983C20 9.31432 19.0561 8.81846 17.6387 8.54088C18.1808 8.769 18.4798 9.05939 18.4798 9.40515C18.4798 10.1717 15.9021 11.6524 12.0685 10.8592C11.6111 10.7646 11.1933 10.6828 10.812 10.6107Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M10.6107 9.18799C11.0208 8.32474 11.3703 6.81094 11.4541 4.98387C11.5863 2.10233 10.7493 -2.37721e-06 9.87983 -2.33921e-06C9.31433 -2.31449e-06 8.81847 0.943943 8.54088 2.36127C8.76901 1.81918 9.05939 1.5202 9.40515 1.5202C10.1717 1.5202 11.6524 4.09794 10.8592 7.9315C10.7646 8.38887 10.6828 8.80673 10.6107 9.18799Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M9.38927 10.812C8.97925 11.6753 8.62971 13.1891 8.54589 15.0161C8.4137 17.8977 9.25072 20 10.1202 20C10.6857 20 11.1815 19.0561 11.4591 17.6387C11.231 18.1808 10.9406 18.4798 10.5949 18.4798C9.82827 18.4798 8.34761 15.9021 9.14076 12.0685C9.23539 11.6111 9.31722 11.1933 9.38927 10.812Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M9.85765 8.99397C9.53717 8.09363 8.71391 6.77605 7.48125 5.42485C5.53716 3.29382 3.45873 2.39911 2.84393 3.0139C2.44406 3.41378 2.76091 4.43187 3.56683 5.63036C3.34482 5.08573 3.33875 4.66899 3.58323 4.4245C4.12529 3.88245 6.99501 4.6582 9.14491 7.92977C9.4014 8.3201 9.63901 8.67343 9.85765 8.99397Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M10.1423 11.006C10.4628 11.9064 11.286 13.224 12.5187 14.5751C14.4628 16.7062 16.5412 17.6009 17.156 16.9861C17.5559 16.5862 17.239 15.5681 16.4331 14.3696C16.6551 14.9143 16.6612 15.331 16.4167 15.5755C15.8747 16.1175 13.0049 15.3418 10.8551 12.0702C10.5986 11.6799 10.3609 11.3266 10.1423 11.006Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M11.006 9.85767C11.9063 9.53719 13.2239 8.71393 14.5751 7.48127C16.7062 5.53719 17.6009 3.45875 16.9861 2.84396C16.5862 2.44409 15.5681 2.76093 14.3696 3.56685C14.9142 3.34484 15.331 3.33877 15.5755 3.58325C16.1175 4.12531 15.3418 6.99503 12.0702 9.14493C11.6799 9.40142 11.3265 9.63903 11.006 9.85767Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M8.99396 10.1423C8.09361 10.4628 6.77603 11.2861 5.42483 12.5187C3.2938 14.4628 2.39909 16.5412 3.01388 17.156C3.41376 17.5559 4.43185 17.2391 5.63034 16.4331C5.08571 16.6552 4.66897 16.6612 4.42448 16.4167C3.88243 15.8747 4.65818 13.005 7.92975 10.8551C8.32008 10.5986 8.67342 10.361 8.99396 10.1423Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M9.0161 9.7465C8.06164 9.69804 6.52931 9.95442 4.80925 10.5762C2.09647 11.5568 0.474475 13.1346 0.8072 13.9379C1.02361 14.4603 2.08546 14.5572 3.50113 14.2713C2.91299 14.268 2.52565 14.1141 2.39334 13.7946C2.09998 13.0864 3.91487 10.732 7.76015 9.99774C8.21892 9.91014 8.63629 9.82584 9.0161 9.7465Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M10.9839 10.2535C11.9384 10.302 13.4707 10.0456 15.1908 9.42383C17.9035 8.44324 19.5255 6.86541 19.1928 6.06214C18.9764 5.53969 17.9146 5.4428 16.4989 5.72874C17.087 5.73204 17.4744 5.88592 17.6067 6.20535C17.9 6.91358 16.0851 9.26799 12.2399 10.0023C11.7811 10.0899 11.3637 10.1742 10.9839 10.2535Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M10.2535 9.01609C10.302 8.06164 10.0456 6.5293 9.42384 4.80924C8.44325 2.09646 6.86542 0.474468 6.06215 0.807193C5.53969 1.0236 5.44281 2.08545 5.72875 3.50112C5.73205 2.91299 5.88592 2.52565 6.20536 2.39333C6.91359 2.09997 9.268 3.91487 10.0023 7.76014C10.0899 8.21891 10.1742 8.63628 10.2535 9.01609Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M9.74651 10.9839C9.69805 11.9384 9.95442 13.4707 10.5762 15.1908C11.5568 17.9035 13.1346 19.5255 13.9379 19.1928C14.4603 18.9764 14.5572 17.9146 14.2713 16.4989C14.268 17.087 14.1141 17.4744 13.7947 17.6067C13.0864 17.9 10.732 16.0851 9.99775 12.2399C9.91015 11.7811 9.82585 11.3637 9.74651 10.9839Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M9.4835 9.12502C8.84287 8.41585 7.57806 7.51361 5.92215 6.73699C3.31054 5.51215 1.04792 5.48092 0.715199 6.28419C0.49879 6.80664 1.18112 7.62599 2.38434 8.42484C1.97081 8.00662 1.80572 7.62393 1.93803 7.30449C2.23139 6.59627 5.17954 6.21477 8.41776 8.41458C8.8041 8.67704 9.15884 8.91255 9.4835 9.12502Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M10.5165 10.875C11.1571 11.5841 12.4219 12.4864 14.0778 13.263C16.6894 14.4879 18.952 14.5191 19.2848 13.7158C19.5012 13.1934 18.8188 12.374 17.6156 11.5752C18.0292 11.9934 18.1942 12.3761 18.0619 12.6955C17.7686 13.4037 14.8204 13.7852 11.5822 11.5854C11.1959 11.323 10.8411 11.0874 10.5165 10.875Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M10.875 9.48352C11.5841 8.84288 12.4864 7.57808 13.263 5.92216C14.4878 3.31056 14.5191 1.04794 13.7158 0.715215C13.1933 0.498807 12.374 1.18114 11.5751 2.38436C11.9934 1.97082 12.3761 1.80574 12.6955 1.93805C13.4037 2.23141 13.7852 5.17955 11.5854 8.41777C11.3229 8.80412 11.0874 9.15885 10.875 9.48352Z"
                          fill="#2C61DD"
                        />
                        <path
                          d="M9.125 10.5165C8.41584 11.1571 7.5136 12.4219 6.73697 14.0778C5.51213 16.6894 5.4809 18.9521 6.28417 19.2848C6.80663 19.5012 7.62598 18.8189 8.42482 17.6156C8.00661 18.0292 7.62391 18.1943 7.30448 18.0619C6.59625 17.7686 6.21475 14.8204 8.41457 11.5822C8.67702 11.1959 8.91254 10.8411 9.125 10.5165Z"
                          fill="#2C61DD"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_4011_1559">
                          <rect width={20} height={20} fill="white" />
                        </clipPath>
                      </defs>
                    </svg>{" "}
                    Events
                  </h5>
                  <div className="space24" />
                  <h2 className="text-anime-style-3">Our Success All Project</h2>
                </div>
              </div>
            </div>
            <div className="row mt-60">
              <div className="col-lg-12">
                <div className="case18-slider-area owl-carousel">
                  <div className="case18-boxarea">
                    <div className="img1 image-anime">
                      <img src="assets/img/service/service-h18-img1.png" alt="" />
                    </div>
                    <div className="text-area">
                      <p>staffing solution</p>
                      <div className="space16" />
                      <a href="case-single.html">Real-World Staffing Solutions</a>
                      <div className="arrow18">
                        <a href="case-single.html">
                          <i className="fa-solid fa-arrow-right" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="case18-boxarea">
                    <div className="img1 image-anime">
                      <img src="assets/img/service/service-h18-img2.png" alt="" />
                    </div>
                    <div className="text-area">
                      <p>staffing success</p>
                      <div className="space16" />
                      <a href="case-single.html">Client Success Highlights</a>
                      <div className="arrow18">
                        <a href="case-single.html">
                          <i className="fa-solid fa-arrow-right" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="case18-boxarea">
                    <div className="img1 image-anime">
                      <img src="assets/img/service/service-h18-img3.png" alt="" />
                    </div>
                    <div className="text-area">
                      <p>staffing Challenge</p>
                      <div className="space16" />
                      <a href="case-single.html">Transforming Challenges Into</a>
                      <div className="arrow18">
                        <a href="case-single.html">
                          <i className="fa-solid fa-arrow-right" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="case18-boxarea">
                    <div className="img1 image-anime">
                      <img src="assets/img/service/service-h18-img4.png" alt="" />
                    </div>
                    <div className="text-area">
                      <p>staffing solution</p>
                      <div className="space16" />
                      <a href="case-single.html">Real-World Staffing Solutions</a>
                      <div className="arrow18">
                        <a href="case-single.html">
                          <i className="fa-solid fa-arrow-right" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="case18-boxarea">
                    <div className="img1 image-anime">
                      <img src="assets/img/service/service-h18-img1.png" alt="" />
                    </div>
                    <div className="text-area">
                      <p>staffing success</p>
                      <div className="space16" />
                      <a href="case-single.html">Client Success Highlights</a>
                      <div className="arrow18">
                        <a href="case-single.html">
                          <i className="fa-solid fa-arrow-right" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="case18-boxarea">
                    <div className="img1 image-anime">
                      <img src="assets/img/service/service-h18-img2.png" alt="" />
                    </div>
                    <div className="text-area">
                      <p>staffing Challenge</p>
                      <div className="space16" />
                      <a href="case-single.html">Transforming Challenges Into</a>
                      <div className="arrow18">
                        <a href="case-single.html">
                          <i className="fa-solid fa-arrow-right" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/*===== CASE AREA ENDS =======*/}








        {/*===== SERVICE AREA START =====*/}
        {/* <div className="service15-section sp">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-5">
          <div className="heading16">
            <h5 data-aos="fade-left" data-aos-duration={900}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={17}
                height={18}
                viewBox="0 0 17 18"
                fill="none"
              >
                <path
                  d="M8.49935 0.667969C8.81213 0.667969 9.12046 0.684913 9.42435 0.718802C9.53313 0.73084 9.63847 0.764185 9.73436 0.816934C9.83025 0.869684 9.91482 0.940803 9.98322 1.02623C10.0516 1.11166 10.1025 1.20973 10.133 1.31483C10.1635 1.41994 10.1731 1.53002 10.161 1.6388C10.149 1.74758 10.1156 1.85292 10.0629 1.94881C10.0101 2.04471 9.93901 2.12927 9.85358 2.19767C9.76815 2.26608 9.67009 2.31699 9.56498 2.34749C9.45988 2.378 9.34979 2.38751 9.24102 2.37547C7.86772 2.22184 6.48062 2.49875 5.27158 3.1679C4.06254 3.83706 3.09131 4.86538 2.49224 6.11063C1.89316 7.35589 1.69585 8.75653 1.92759 10.1188C2.15933 11.4811 2.80867 12.7377 3.7858 13.7149C4.76292 14.692 6.01954 15.3413 7.38183 15.5731C8.74412 15.8048 10.1448 15.6075 11.39 15.0084C12.6353 14.4093 13.6636 13.4381 14.3327 12.2291C15.0019 11.02 15.2788 9.63293 15.1252 8.25964C15.1131 8.15086 15.1227 8.04077 15.1532 7.93567C15.1837 7.83056 15.2346 7.7325 15.303 7.64707C15.4411 7.47453 15.6422 7.36395 15.8618 7.33964C16.0815 7.31532 16.3019 7.37928 16.4744 7.51743C16.5598 7.58584 16.631 7.6704 16.6837 7.76629C16.7365 7.86218 16.7698 7.96752 16.7818 8.0763C16.8152 8.38019 16.8321 8.68852 16.8327 9.0013C16.8327 13.6038 13.1018 17.3346 8.49935 17.3346C3.89685 17.3346 0.166016 13.6038 0.166016 9.0013C0.166016 4.3988 3.89685 0.667969 8.49935 0.667969ZM8.47268 5.56547C8.5276 5.77941 8.49534 6.00639 8.383 6.19656C8.27065 6.38672 8.0874 6.52451 7.87352 6.57964C7.28591 6.73356 6.77438 7.09603 6.43438 7.59939C6.09438 8.10276 5.94914 8.71264 6.02577 9.31522C6.10239 9.9178 6.39564 10.4719 6.8508 10.8742C7.30595 11.2764 7.89192 11.4993 8.49935 11.5013C9.05377 11.5015 9.59254 11.3175 10.0309 10.978C10.4693 10.6386 10.7824 10.1631 10.921 9.6263C10.9801 9.4166 11.1189 9.23836 11.3078 9.12978C11.4967 9.0212 11.7206 8.9909 11.9315 9.04538C12.1425 9.09986 12.3237 9.23478 12.4364 9.42125C12.549 9.60771 12.5842 9.83089 12.5343 10.043C12.2787 11.0229 11.675 11.8763 10.8361 12.4436C9.99724 13.011 8.98048 13.2535 7.97582 13.1259C6.97115 12.9983 6.0473 12.5093 5.37685 11.7502C4.70641 10.9912 4.33524 10.014 4.33268 9.0013C4.33254 8.07746 4.63943 7.17977 5.20511 6.44936C5.77079 5.71896 6.56318 5.19726 7.45768 4.9663C7.56367 4.93898 7.674 4.93281 7.78238 4.94814C7.89075 4.96347 7.99504 5 8.0893 5.05564C8.18355 5.11128 8.26592 5.18494 8.3317 5.27242C8.39748 5.35989 8.44539 5.45947 8.47268 5.56547ZM13.9193 0.773802C14.0715 0.836868 14.2015 0.943583 14.293 1.08048C14.3845 1.21737 14.4334 1.37831 14.4335 1.54297V3.06797H15.9577C16.1225 3.068 16.2836 3.1169 16.4206 3.20847C16.5576 3.30004 16.6644 3.43017 16.7274 3.58242C16.7905 3.73467 16.807 3.9022 16.7748 4.06383C16.7427 4.22546 16.6634 4.37393 16.5469 4.49047L13.5993 7.43464C13.4431 7.59093 13.2312 7.67876 13.0102 7.6788H10.9993L9.47602 9.20297C9.31965 9.35934 9.10757 9.44718 8.88643 9.44718C8.6653 9.44718 8.45322 9.35934 8.29685 9.20297C8.14048 9.0466 8.05264 8.83452 8.05264 8.61339C8.05264 8.39225 8.14048 8.18017 8.29685 8.0238L9.82102 6.5013V4.48964C9.82106 4.26864 9.90889 4.05671 10.0652 3.90047L13.011 0.953802C13.1276 0.837191 13.2761 0.757767 13.4377 0.725578C13.5994 0.693389 13.767 0.709881 13.9193 0.772969M12.7668 3.5538L11.4877 4.83464V6.01297H12.666L13.946 4.7338H13.6002C13.3792 4.7338 13.1672 4.646 13.0109 4.48972C12.8546 4.33344 12.7668 4.12148 12.7668 3.90047V3.5538Z"
                  fill="#120734"
                />
              </svg>{" "}
              Our Services
            </h5>
            <div className="space12" />
            <h2 className="text-anime-style-3">
              Tailored Solutions to Fuel Your Business Growth
            </h2>
          </div>
        </div>
        <div className="col-lg-4" />
        <div className="col-lg-3">
          <div className="btn-area1 text-end">
            <a href="service.html" className="theme-btn29">
              View More Services
            </a>
          </div>
        </div>
      </div>
      <div className="row mt-30">
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={900}
        >
          <div className="service15-boxarea">
            <div className="img1">
              <img src="assets/img/service/service15-img1.png" alt="" />
            </div>
            <div className="space20" />
            <div className="content15-service">
              <a href="service-details1.html" className="title">
                Website Optimization
              </a>
              <div className="space16" />
              <p>Improve a website’s speed, structure, &amp; usability With.</p>
              <div className="space24" />
              <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a>
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1000}
        >
          <div className="service15-boxarea">
            <div className="img1">
              <img src="assets/img/service/service15-img2.png" alt="" />
            </div>
            <div className="space20" />
            <div className="content15-service">
              <a href="service-details1.html" className="title">
                Link Building &amp; Outreach
              </a>
              <div className="space16" />
              <p>Our link-building strategies help you earn high-quality</p>
              <div className="space24" />
              <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a>
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1100}
        >
          <div className="service15-boxarea">
            <div className="img1">
              <img src="assets/img/service/service15-img3.png" alt="" />
            </div>
            <div className="space20" />
            <div className="content15-service">
              <a href="service-details1.html" className="title">
                Creation &amp; Marketing
              </a>
              <div className="space16" />
              <p>Engage your audience with SEO-optimized content</p>
              <div className="space24" />
              <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a>
            </div>
          </div>
        </div>
        <div
          className="col-lg-3 col-md-6"
          data-aos="fade-up"
          data-aos-duration={1200}
        >
          <div className="service15-boxarea">
            <div className="img1">
              <img src="assets/img/service/service15-img4.png" alt="" />
            </div>
            <div className="space20" />
            <div className="content15-service">
              <a href="service-details1.html" className="title">
                Local SEO Services
              </a>
              <div className="space16" />
              <p>Get found local customers with our local SEO services.</p>
              <div className="space24" />
              <a href="service-details1.html" className="readmore">
                Read More <i className="fa-solid fa-arrow-right" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> */}
        {/*===== SERVICE AREA END =====*/}















        {/*=== BLOG AREA START === */}
       
        {/*=== BLOG AREA END === */}







        {/*=== WORK AREA START === */}
        {/* <div className="work6 sp">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7 m-auto text-cneter">
                                <div className="heading6 _mt-50 text-center">
                                    <span className="sub-title">Work Process</span>
                                    <h2 className="text-anime-style-3">
                                        Our Proven Staffing Process From Search to Success
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-30">
                            <div className="col-lg-6">
                                <div className="image image-anime reveal mt-30">
                                    <img src="assets/img/work/work6-image.png" alt="" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="work6-items mt-30 ml-40 md:ml-0 sm:ml-0">
                                    <div className="work6-single-item">
                                        <div className="icon">
                                            <div className="point" />
                                        </div>
                                        <div className="text heading6">
                                            <h4>
                                                <a href="#">Placement and Onboarding Support</a>
                                            </h4>
                                            <p className="mt-16">
                                                After you’ve selected your ideal candidate, we assist with the
                                                onboarding process to ensure a smooth transition.
                                            </p>
                                            <a href="#" className="learn">
                                                Read More{" "}
                                                <span className="arrow1">
                                                    <i className="fa-solid fa-arrow-right" />
                                                </span>
                                                <span className="arrow2">
                                                    <i className="fa-solid fa-arrow-right" />
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="work6-single-item">
                                        <div className="icon">
                                            <div className="point" />
                                        </div>
                                        <div className="text heading6">
                                            <h4>
                                                <a href="#">Client and Candidate Matching</a>
                                            </h4>
                                            <p className="mt-16">
                                                We go beyond the resume to ensure the perfect match. By
                                                aligning the goals of both our clients &amp; candidates.
                                            </p>
                                            <a href="#" className="learn">
                                                Read More{" "}
                                                <span className="arrow1">
                                                    <i className="fa-solid fa-arrow-right" />
                                                </span>
                                                <span className="arrow2">
                                                    <i className="fa-solid fa-arrow-right" />
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="work6-single-item">
                                        <div className="icon">
                                            <div className="point" />
                                        </div>
                                        <div className="text heading6">
                                            <h4>
                                                <a href="#">Follow-Up and Feedback</a>
                                            </h4>
                                            <p className="mt-16">
                                                Our work doesn’t after placement. We maintain ongoing
                                                communication to ensure satisfaction for both the client
                                            </p>
                                            <a href="#" className="learn">
                                                Read More{" "}
                                                <span className="arrow1">
                                                    <i className="fa-solid fa-arrow-right" />
                                                </span>
                                                <span className="arrow2">
                                                    <i className="fa-solid fa-arrow-right" />
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="work6-single-item">
                                        <div className="icon">
                                            <div className="point" />
                                        </div>
                                        <div className="text heading6">
                                            <h4>
                                                <a href="#">Candidate Presentation</a>
                                            </h4>
                                            <p className="mt-16">
                                                Once we identify top-tier candidates we present you with a
                                                curated shortlist, complete with detailed profiles.
                                            </p>
                                            <a href="#" className="learn">
                                                Read More{" "}
                                                <span className="arrow1">
                                                    <i className="fa-solid fa-arrow-right" />
                                                </span>
                                                <span className="arrow2">
                                                    <i className="fa-solid fa-arrow-right" />
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
        {/*=== WORK AREA END === */}


        {/*==== BLOG AREA START =====*/}
        {/*==== CTA AREA START =====*/}
        {/* <div className="cta10"
        
        style={{
            backgroundImage: "url(assets/img/bg/)",
            backgroundPosition: "center bottom",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
          }}>
          <div className="container">
            <div className="cta10-bg">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="white-heading">
                    <h2>Ready To Elevate Your Startup?</h2>
                    <p className="mt-16">
                      At SEOX, we help ambitious startups scale faster with powerful
                      SEO strategies, data-driven marketing, and growth-focused
                      solutions. At whether you looking boost visibility, drive lead,
                      dominate industry.
                    </p>
                    <div className="buttons mt-40">
                      <a
                        href="service.html"
                        className="theme-btn20"
                        bis_skin_checked={1}
                      >
                        Start Growing Today
                        <span className="arrow1">
                          <i className="fa-solid fa-arrow-right" />
                        </span>
                        <span className="arrow2">
                          <i className="fa-solid fa-arrow-right" />
                        </span>
                      </a>
                      <a
                        href="service.html"
                        className="theme-btn21 ml-16 md:ml-0 sm:ml-0 sm:mt-20 sm:mr-20"
                        bis_skin_checked={1}
                      >
                        Get Started Now
                        <span className="arrow1">
                          <i className="fa-solid fa-arrow-right" />
                        </span>
                        <span className="arrow2">
                          <i className="fa-solid fa-arrow-right" />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/*====  CTA  AREA END =====*/}
      </main >


      <Footer />
    </>
  );
}


export default Home;